import http from '../plugins/axios';
export async function get_all_list_order(payload) {
    const response = await http.get('cashier/order-report', { params: payload });
    return response.data;
}

export async function order_print_preview(payload) {
    const response = await http.get('cashier/order-report-print-preview', { params: payload });

    return response.data;
}

// export async function update_is_paid_order(input) {
//     const respone = await http.post('update-is-paid', input);
//     return respone;
// }

export async function pay_order(payload) {
    const respone = await http.post('cashier/order/pay-order', payload);
    return respone;
}


export async function move_table(payload) {
    const response = await http.post('order/change-location', payload);
    return response.data;
}

export async function split_person(payload) {
    const response = await http.post('cashier/order/split-person', payload);
    return response.data;
}

export async function get_cashier(payload) { 
    const response = await http.get('cashier/cashiers', { params: {
        restaurant_id: payload
    } }); 
    return response.data;
}
 